// FirstTourAnswersPopover.tsx
import React from 'react';
import { Popover, Button, Table, Tag } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { Participant, FirstTourAnswer } from './TeacherOlympiadList';

interface FirstTourAnswersPopoverProps {
    participant: Participant;
    answers: FirstTourAnswer[];
}

const FirstTourAnswersPopover: React.FC<FirstTourAnswersPopoverProps> = ({ participant, answers }) => {
    const columns = [
        {
            title: '№ задания',
            key: 'taskOrder',
            width: 100,
            render: (value: any, record: FirstTourAnswer, index: number) => index + 1,
        },
        {
            title: 'Правильный ответ',
            dataIndex: 'correctAnswer',
            key: 'correctAnswer',
            render: (answer: string) => <Tag color="green">{answer}</Tag>,
        },
        {
            title: 'Ответ участника',
            dataIndex: 'participantAnswer',
            key: 'participantAnswer',
            render: (answer: string, record: FirstTourAnswer) => (
                <Tag color={answer.replaceAll(/\s+/g, '') === record.correctAnswer.replaceAll(/\s+/g, '') ? 'green' : 'red'}>
                    {answer || 'Не ответил'}
                </Tag>
            ),
        },
    ];

    const content = (
        <div style={{ width: 400 }}>
            <Table
                dataSource={answers}
                columns={columns}
                pagination={false}
                size="small"
                scroll={{ y: 300 }}
                rowKey="taskId"
            />
        </div>
    );

    return (
        <Popover content={content} title="Ответы первого тура" trigger="click">
            <Button type="link" icon={<EyeOutlined />} size="small">
                Ответы
            </Button>
        </Popover>
    );
};

export default FirstTourAnswersPopover;